import { useState, useEffect } from "react";
import api, { formatApiError } from "../../lib/api";
import { Card } from "../ui/card";
import { Badge } from "../ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function StockMovementsPanel({ params, refresh }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/sales/stock-movements", { params }).then(({ data }) => setRows(data)).catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  }, [params.from_date, params.to_date, refresh]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!rows) return <div className="flex items-center gap-2 text-muted-foreground"><Loader2 className="w-4 h-4 animate-spin" /> Carico…</div>;
  return (
    <Card className="rounded-xl overflow-hidden" data-testid="stock-movements-panel">
      <div className="p-4 border-b border-border text-sm font-medium">{rows.length} scarichi magazzino nel periodo</div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Data</TableHead><TableHead>Piatto venduto</TableHead><TableHead className="text-right">Q.tà</TableHead><TableHead>Ricetta</TableHead><TableHead>Ingredienti scaricati</TableHead><TableHead>Origine</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-8">Nessuno scarico. Usa "Scarica magazzino (periodo)" dopo aver importato il venduto.</TableCell></TableRow>}
            {rows.map((m) => (
              <TableRow key={m.id} data-testid={`movement-${m.id}`}>
                <TableCell className="whitespace-nowrap">{m.date}</TableCell>
                <TableCell className="font-medium">{m.product}</TableCell>
                <TableCell className="text-right">{m.qty}</TableCell>
                <TableCell>{m.recipe}</TableCell>
                <TableCell className="text-xs">
                  <div className="flex flex-wrap gap-1">
                    {(m.lines || []).map((l, i) => <Badge key={i} variant="outline" className={`rounded-full ${l.inventory_id ? "" : "border-amber-500 text-amber-700"}`} title={l.inventory_id ? `Magazzino: ${l.inventory_name}` : "Non trovato in magazzino"}>{l.ingredient} −{l.qty} {l.unit}</Badge>)}
                  </div>
                </TableCell>
                <TableCell><Badge variant="secondary" className="rounded-full">{m.source === "sospeso" ? "Sospeso" : "Cassa"}</Badge></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
}
